<div class="container">
    <div *ngIf="!isRejected()" class="circular-progress" #circularProgress>
        <span class="progress-value">{{ getProgressText() }}</span>
    </div>
    <div *ngIf="isRejected()">
        <i
            class="fa fa-ban fa-3x"
            aria-hidden="true"
            [ngStyle]="{ color: 'var(--color-danger)' }"
        ></i>
    </div>
    <div class="status-description">
        <h3 class="emd-text _size_section _color_default">
            <strong>{{ getCurrentStatusName() }}</strong>
        </h3>
        <p *ngIf="!isComplete() && !isRejected() && !hideNextStep">
            <strong>Próximo:</strong>
            {{ getNextStatusName() }}
        </p>
        <p>
            {{ getStatusDescription() }}
        </p>
    </div>
</div>
